import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {ErrorBoundary} from 'react-error-boundary';

// Note: tailwind.css is already loaded by the Shopify theme, don't import here
// to avoid CSS reset conflicts that break the layout

// Use lazy-loading wrapper to avoid blocking page load with heavy Solana dependencies
// The full wallet stack (~1.4MB) is only loaded when user clicks "Connect Now"
import {LazyWalletButton} from './Components/Solana/LazyWalletButton.jsx';

function fallbackRender({error}) {
  return (
    <div style={{display: 'block'}} role="alert">
      <p>Something went wrong:</p>
      <pre style={{color: 'red'}}>{error.message}</pre>
    </div>
  );
}

function initializeWalletConnect() {
  const walletRoot = document.getElementById('solana-connect-header');

  if (!walletRoot) {
    return false;
  }

  const burnNftBtn = document.getElementById('burn-btn');
  const {rpcServerEndpoint, collectionOg, collectionSaga} = walletRoot.dataset || {};

  // Build array of collection addresses from theme settings
  const collectionAddresses = [collectionOg, collectionSaga].filter(Boolean);

  const root = createRoot(walletRoot);

  root.render(
    <StrictMode>
      <ErrorBoundary fallback={fallbackRender}>
        <LazyWalletButton
          rpcServerEndpoint={rpcServerEndpoint}
          collectionAddresses={collectionAddresses}
          burnNftBtn={burnNftBtn}
        />
      </ErrorBoundary>
    </StrictMode>,
  );

  return true;
}

// Try to initialize immediately
if (!initializeWalletConnect()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!initializeWalletConnect()) {
        const observer = new MutationObserver(() => {
          if (initializeWalletConnect()) {
            observer.disconnect();
          }
        });
        observer.observe(document.body, {childList: true, subtree: true});
      }
    });
  } else {
    const observer = new MutationObserver(() => {
      if (initializeWalletConnect()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }
}
